var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.9922C3.23858 14.9922 1 12.7536 1 9.99219C1 7.54372 2.75992 5.50631 5.08376 5.07595C5.51412 2.75211 7.55154 0.992188 10 0.992188C12.4485 0.992188 14.4859 2.75211 14.9162 5.07595C17.2401 5.50631 19 7.54372 19 9.99219C19 12.7536 16.7614 14.9922 14 14.9922M7 17.9922L10 20.9922M10 20.9922L13 17.9922M10 20.9922V8.99219",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudStorage);
export default __webpack_public_path__ + "static/media/CloudStorage.4980f7938f46d92ce6c4b0339a8bd9d0.svg";
export { ForwardRef as ReactComponent };